<div class="d-flex justify-content-between align-items-center">
  <div>
    <span class="collapseAllButton" (click)="toggleAllCollapse()">
      <sb-icon *ngIf="isAllCollapsed" icon="chevronRight"></sb-icon>
      <sb-icon *ngIf="!isAllCollapsed" icon="chevronDown"></sb-icon>
    </span>
    {{'lang.globals.campaigns' | translate}}
  </div>
  <div>
    <button class="btn btn-default mr-1"
            (click)="bookingEditor.sortCampaigns('Basic')">{{'lang.globals.clientOrderNum' | translate}}
      <sb-icon style="font-size: 0.75rem"
               *ngIf="bookingEditor.resourceStore.isSorted && bookingEditor.sortedColumn === 'Basic' && !resolveSortIcon()"
               icon="arrowUp"></sb-icon>
      <sb-icon style="font-size: 0.75rem"
               *ngIf="bookingEditor.resourceStore.isSorted && bookingEditor.sortedColumn === 'Basic' && resolveSortIcon()"
               icon="arrowDown"></sb-icon>
    </button>
    <button class="btn btn-default mr-1"
            (click)="bookingEditor.sortCampaigns('Name')">{{'lang.globals.name' | translate}}
      <sb-icon style="font-size: 0.75rem"
               *ngIf="bookingEditor.resourceStore.isSorted && bookingEditor.sortedColumn === 'Name' && !resolveSortIcon()"
               icon="arrowUp"></sb-icon>
      <sb-icon style="font-size: 0.75rem"
               *ngIf="bookingEditor.resourceStore.isSorted && bookingEditor.sortedColumn === 'Name' && resolveSortIcon()"
               icon="arrowDown"></sb-icon>
    </button>
    <button class="btn btn-default" (click)="bookingEditor.sortCampaigns('Level')">{{'lang.globals.level' | translate}}
      <sb-icon style="font-size: 0.75rem"
               *ngIf="bookingEditor.resourceStore.isSorted && bookingEditor.sortedColumn === 'Level' && !resolveSortIcon()"
               icon="arrowUp"></sb-icon>
      <sb-icon style="font-size: 0.75rem"
               *ngIf="bookingEditor.resourceStore.isSorted && bookingEditor.sortedColumn === 'Level' && resolveSortIcon()"
               icon="arrowDown"></sb-icon>
    </button>
  </div>
</div>
